module.exports = __webpack_public_path__ + "img/scene-diplomat.6dffae1c.svg";